<template>
  <AppTextField
    v-bind="fieldProps"
    v-mask="mask"
    :model-value="modelValue"
    @update:model-value="$emit('update:modelValue', $event)"
  />
</template>

<script setup lang="ts">
import { computed } from "vue";
import AppTextField from "./AppTextField.vue";

const props = withDefaults(
  defineProps<{
    modelValue: string;
    label?: string;
    placeholder?: string;
    mask?: string;
    disabled?: boolean;
    errorMessages?: string | string[];
  }>(),
  {
    mask: "(###) ###-####",
    label: "Phone",
    placeholder: "",
    disabled: false,
    errorMessages: () => [],
  },
);

const fieldProps = computed(() => ({
  label: props.label,
  placeholder: props.placeholder,
  disabled: props.disabled,
  errorMessages: props.errorMessages,
}));
</script>
